(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
  class StickyAddToCart extends HTMLElement {
    /** @type {AbortController | undefined} */
    #controller;
    /** @type {IntersectionObserver | undefined} */
    #observer;

    connectedCallback() {
      const form = document.querySelector('form[id^="BuyButtons-ProductForm-"]');
      const button = this.querySelector('.sticky-atc__button');
      if (!(form instanceof HTMLFormElement) || !(button instanceof HTMLButtonElement)) return;

      this.#controller = new AbortController();
      button.addEventListener('click', () => form.requestSubmit(), { signal: this.#controller.signal });

      const target = form.closest('product-form-component') || form;
      this.#observer = new IntersectionObserver(([entry]) => {
        if (!entry) return;
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.toggleAttribute('data-visible', scrolledPast);
        this.inert = !scrolledPast;
      });
      this.#observer.observe(target);
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#observer?.disconnect();
    }
  }

  if (!customElements.get('sticky-add-to-cart')) {
    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }

  } catch(e) { console.error(e); }
})();
})();
